import React, { useCallback } from "react";
import AdicionarAtividadeExcepcional from "./AdicionarAtividadeExcepcional";
import { useSelector, useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { getAtividadesExcepcionais } from "../../../../selectors/dominios.selectors";
import validators from "../../../../utils/validators";
import { actions as domainActions } from "../../../../reducers/dominios.actions";
import { actions } from "../../../../reducers/propostas.actions";

const AdicionarAtividadeExcepcionalConnected = ({
  handleClose,
  dados,
  loadingAbrirAtividade,
  proposta,
}) => {
  const dispatch = useDispatch();
  const { loading, data: dominioAtividades } = useSelector(
    getAtividadesExcepcionais
  );

  const rules = {
    atividade: validators.string({ required: true }),
  };
  const initialValues = {
    atividade: "",
  };
  const formProps = {
    ...useForm(),
    rules,
    initialValues,
  };

  const handleOpen = useCallback(() => {
    dispatch(
      domainActions.atividadesExcepcionais.request({
        id: proposta,
      })
    );
  }, [dispatch, proposta]);

  const handleSubmit = useCallback(
    ({ atividade }) => {
      dispatch(
        actions.abrirAtividade.request({
          consulta: dados.proposta,
          atividade: atividade,
          condicaoCriacao: "E",
          handleClose,
        })
      );
    },
    [dispatch, dados, handleClose]
  );

  return (
    <AdicionarAtividadeExcepcional
      handleSubmit={handleSubmit}
      handleOpen={handleOpen}
      open={dados.open}
      loading={loading}
      formProps={formProps}
      dominioAtividades={dominioAtividades}
      handleClose={handleClose}
      submitting={loadingAbrirAtividade}
    />
  );
};

export default AdicionarAtividadeExcepcionalConnected;
